import styled, { css } from 'styled-components';

import Box from '../../_shared/components/Box';
import Button from '../../_shared/components/Button';

const StyledButtonVariant = {
  prev: css`
    margin-left: 14.2px;
    padding-right: 30px;
  `,
  next: css`
    margin-right: 14.2px;
    padding-left: 30px;
  `
};

export const StyledPageBar = styled(Box.Column)`
  width: 100%;
  height: 54px;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  background: ${({ theme }) => theme.COLORS.BASE};
  margin: 7px 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  ${({ isOmp }) =>
    isOmp &&
    css`
      border: ${({ theme }) => `1px solid ${theme.COLORS.NEUTRAL_110}`};
      box-shadow: none;
    `}
`;

export const StyledButton = styled(Button.Transparent)`
  border: 2px solid ${({ theme }) => theme.COLORS.BASE_INVERTED};
  box-sizing: border-box;
  border-radius: 4px;
  height: 30px;
  width: 113px;
  display: flex;
  align-items: inherit;
  padding: 6px 0px;
  justify-content: space-around;
  svg {
    width: 24px;
    height: 12px;
  }
  ${props => StyledButtonVariant[props.variant]}
`;

export const PageNumber = styled.div`
  margin: auto;
`;
